/* eslint-disable react-hooks/exhaustive-deps */
/* ============================================================
   JU รับสินค้าเข้าสต๊อก — หน้ารายการ
============================================================ */
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Card, Collapse, Form, Flex, Row, Col, Space, Select, Input, Button,
  Table, Typography, DatePicker, message,
} from "antd";
import { SearchOutlined, ClearOutlined } from "@ant-design/icons";
import { MdOutlineLibraryAdd } from "react-icons/md";
import dayjs from "dayjs";

import { accessColumn, JU_STATUS } from "./model";
import useAccessPageState from "../../../hooks/useAccessPageState";
import JuService from "../../../service/ERP/Ju.service";

const juService = JuService();
const { RangePicker } = DatePicker;

const JuAccess = () => {
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [rows, setRows] = useState([]);
  const [activeSearch, setActiveSearch] = useState([]);
  const {
    tablePagination,
    saveState,
    restoreState,
    clearState,
    restoreDefaultPagination,
    handleTableChange,
  } = useAccessPageState({ form });

  const handleSearch = (forcedValues = null, paginationOverride = null) => {
    const run = (v) => {
      saveState(v, paginationOverride ?? tablePagination);
      const data = { ...v };
      if (data.judate?.length === 2) {
        data.judate_from = dayjs(data.judate[0]).format("YYYY-MM-DD");
        data.judate_to = dayjs(data.judate[1]).format("YYYY-MM-DD");
      }
      delete data.judate;
      juService
        .search(data, { ignoreLoading: Object.keys(data).length !== 0 })
        .then((res) => setRows(res.data?.data || []))
        .catch(() => message.error("Request error!"));
    };
    if (useAccessPageState.canUseForcedSearchValues(forcedValues)) {
      run(forcedValues);
      return;
    }
    form.validateFields().then(run);
  };

  const handleClear = () => {
    clearState();
    form.resetFields();
    handleSearch({}, restoreDefaultPagination());
  };

  const go = (action, r) =>
    navigate(`manage/${action}`, {
      state: {
        config: {
          action,
          code: r?.jucode || null,
          title:
            action === "create"
              ? "สร้างJU รับสินค้าเข้าสต๊อก"
              : action === "edit"
              ? "แก้ไขJU รับสินค้าเข้าสต๊อก"
              : "JU รับสินค้าเข้าสต๊อก",
        },
      },
    });

  const handleCancel = (r) =>
    juService
      .cancel(r.jucode)
      .then(() => {
        message.success("ยกเลิกเอกสารแล้ว");
        handleSearch();
      })
      .catch((err) => message.error(err?.response?.data?.message || "ยกเลิกไม่สำเร็จ"));

  useEffect(() => {
    const restored = restoreState();
    handleSearch(restored?.searchValues ?? null, restored?.tablePagination);
  }, []);

  const FormSearch = (
    <Collapse
      size="small"
      bordered={false}
      activeKey={activeSearch}
      onChange={setActiveSearch}
      items={[
        {
          key: "1",
          label: (
            <>
              <SearchOutlined /> <span>ค้นหา</span>
            </>
          ),
          children: (
            <Form form={form} layout="vertical" autoComplete="off">
              <Row gutter={[8, 8]}>
                <Col xs={24} sm={12} md={6}>
                  <Form.Item label="เลขที่ JU" name="jucode">
                    <Input size="large" placeholder="JU..." allowClear />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={6}>
                  <Form.Item label="สินค้า (รหัส/ชื่อ)" name="stcode">
                    <Input size="large" placeholder="รหัสหรือชื่อสินค้า" allowClear />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={6}>
                  <Form.Item label="วันที่" name="judate">
                    <RangePicker size="large" style={{ width: "100%" }} />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={6}>
                  <Form.Item label="สถานะ" name="doc_status">
                    <Select
                      size="large"
                      allowClear
                      placeholder="ทั้งหมด"
                      options={JU_STATUS.map((s) => ({ value: s, label: s }))}
                    />
                  </Form.Item>
                </Col>
              </Row>
              <Flex justify="end" gap={8}>
                <Button type="primary" size="small" className="bn-action" icon={<SearchOutlined />} onClick={() => handleSearch()}>
                  ค้นหา
                </Button>
                <Button type="primary" size="small" className="bn-action" danger icon={<ClearOutlined />} onClick={handleClear}>
                  ล้าง
                </Button>
              </Flex>
            </Form>
          ),
        },
      ]}
    />
  );

  return (
    <Space direction="vertical" size="middle" style={{ display: "flex" }}>
      {FormSearch}
      <Card>
        <Flex justify="space-between" align="center" className="mb-3">
          <Typography.Title level={3} className="m-0 !text-zinc-800">
            JU รับสินค้าเข้าสต๊อก
          </Typography.Title>
          <Button
            className="bn-action bn-center bn-primary-outline justify-center"
            icon={<MdOutlineLibraryAdd style={{ fontSize: "1.2rem" }} />}
            onClick={() => go("create")}
          >
            สร้าง JU
          </Button>
        </Flex>
        <Table
          size="small"
          rowKey="jucode"
          columns={accessColumn({
            handleView: (r) => go("view", r),
            handleEdit: (r) => go("edit", r),
            handleCancel,
          })}
          dataSource={rows}
          scroll={{ x: "max-content" }}
          pagination={tablePagination}
          onChange={handleTableChange}
        />
      </Card>
    </Space>
  );
};

export default JuAccess;
